export const ATTACHABLES = {
  EHC_SERVICE_ORDER: 'Ehc::ServiceOrder',
  AFYA_MEDICAL_RESULT: 'Simrs::Afya::MedicalResult',
};

export const ATTACHABLES_LABELS = {
  [ATTACHABLES.EHC_SERVICE_ORDER]: 'EHC Service Order',
  [ATTACHABLES.AFYA_MEDICAL_RESULT]: 'Afya Medical Result',
};

// Afya medical results are created by hermina-core when Afya pushes a document;
// admins never attach one by hand, so the form's type select excludes them.
const HAND_CREATABLE_ATTACHABLES = [ATTACHABLES.EHC_SERVICE_ORDER];

export const ATTACHABLES_OPTIONS = HAND_CREATABLE_ATTACHABLES.map(key => ({
  value: key,
  label: ATTACHABLES_LABELS[key],
}));
